// export const DecorativeBackground2
//  = () => {
//   return (
//     <div
//       className="relative w-[2665px] h-[2544px] overflow-hidden"
//       data-model-id="3125:6279-frame"
//     >
//       <div className="fixed top-[251px] left-[-501px] w-[2665px] h-[2544px]">
//         <img
//           className="absolute top-[921px] left-[501px] w-[1920px] h-[773px]"
//           alt="Rectangle"
//           src="/images/rectangle-34625682.svg"
//         />

//         <img
//           className="absolute w-[81.20%] h-full top-0 left-[18.80%]"
//           alt="Group"
//           src="/images/group.svg"
//         />
//       </div>
//     </div>
//   );
// };


export const DecorativeBackground2 = () => {
  return (
    <div>
      <div className="hidden lg:block">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">

      {/* red gradient background */}
      <img
        src="/images/rectangle-34625682.svg"
        alt=""
        className="absolute w-full h-full object-cover"
      />

      {/* wave pattern */}
      <img
        src="/images/group.svg"
        alt=""
        className="absolute right-0 top-0 w-[70%] opacity-70"
      />

    </div>
      </div>

      <div className="block lg:hidden">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">

      {/* red gradient background */}
      <img
        src="/images/rectangle-34625682.svg"
        alt=""
        className="absolute w-full h-full object-cover"
      />

      {/* wave pattern */}
      <img
        src="/images/waveMobile.svg"
        alt=""
        className="absolute right-0 top-0 w-[100%] "
      />

    </div>
      </div>
    </div>
    
  );
};